import { UseContextApp } from "../Global/Context/appContext";
import ServerCall from "./ServerCall";
const AuthController = () => {
  const { user } = UseContextApp();

  const register = async (input) => {
    var bodyFormData = new FormData();
    
    bodyFormData.append("tipoDocIdentidad", input.result);
    bodyFormData.append("docIdentidad", input.typeDoc);
    bodyFormData.append("password", input.password);
    bodyFormData.append("correo", input.idCorreo);
    const response = await ServerCall.post(
      '/Autenticacion/Registro',
      bodyFormData
    );
    return response;
  };

  const signIn = async (input) => {
    var bodyFormData = new FormData();
    bodyFormData.append("tipoDocIdentidad", input.result);
    bodyFormData.append("docIdentidad", input.typeDoc);
    bodyFormData.append("password", input.password);
    const response = await ServerCall.post(
      '/Autenticacion/Login',
      bodyFormData
    );
    return response;
  };

  const signOut = async (input) => {

    var body = new FormData();
    const response = await ServerCall.post(
      '/Autenticacion/LoginOut',
      body,
      input.token
    );
    return response.data;
  };

  const verifyDoc = async (input) => {
    var body = new FormData();
    if (input.type !== "CI" && input.type !== "P") {body.append("docIdentidad", input.type + input.id);} 
    else  {body.append("docIdentidad", input.id);}
    const response = await ServerCall.post(
      '/Cliente/DocIdentidad',
      body,
      input.token
    );
    return response;
  };

  const registerDoc = async (input) => {

    var body = new FormData();
    if (input.tipoDoc !== "CI" && input.tipoDoc !== "P") {body.append("docIdentidad", input.tipoDoc + input.id);} 
    else  {body.append("docIdentidad", input.id);}
    const response = await ServerCall.post(
      `/Autenticacion/DocIdentidad`,
      body
    );
    return response;

  };

  const recoverEmail = async (input) => {
    var body = new FormData();
    body.append("correo", input.email);
    const response = await ServerCall.post(
      `/Autenticacion/Recuperar`,
      body
    );
    return response;

  };


  const recoverConfirm = async (input) => {
    var body = new FormData();
    body.append("token", input.token);
    body.append("contrasena", input.password);
    body.append("confirContrasena", input.passwordConfirm);
    const response = await ServerCall.post(
      `/Autenticacion/Ejecutar`,
      body,
      input.token
    );
    return response;

  };

  const validateToken = async (input) => {

    var body = new FormData();
    body.append("token", input.token);
    const response = await ServerCall.post(
      `/Autenticacion/ValidarToken`,
      body,
      input.token
    );
    return response;
  };

  return {
    register,
    signIn,
    signOut,
    verifyDoc,
    registerDoc,
    recoverEmail,
    recoverConfirm,
    validateToken,
  };
};

export default AuthController;
